/*
 * 1DS JS SDK QoS plugin, 3.2.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
/**
* Utils.ts
* @author  Ram Thiru (ramthi@microsoft.com)
* @copyright Microsoft 2017
* File containing utility functions.
*/
import { arrForEach, isObject, isValueAssigned, objForEachKey } from "@microsoft/1ds-core-js";
export function _removeNonObjectsAndInvalidElements(overrideConfig, attributeNamesExpectedObjects) {
    /// <summary> Finds attributes in overrideConfig which are invalid or should be objects
    /// and deletes them. useful in override config</summary>
    /// <param type='object'>override config object</param>
    /// <param type=''> attributes that should be objects in override config object </param>
    _removeInvalidElements(overrideConfig);
    arrForEach(attributeNamesExpectedObjects, function (objectName) {
        if (isObject(overrideConfig[objectName])) {
            _removeInvalidElements(overrideConfig[objectName]);
        }
        else {
            delete overrideConfig[objectName];
        }
    });
}
export function _removeInvalidElements(object) {
    /// <summary> Finds attributes in object which are invalid
    /// and deletes them. useful in override config </summary>
    /// <remarks> Because the config object 'callback' contains only functions,
    /// when it is stringified it returns the empty object. This explains
    /// the workaround regarding 'callback' </remarks>
    /// <param type='object'>override config object</param>
    objForEachKey(object, function (property, value) {
        if (!isValueAssigned(value) ||
            (JSON.stringify(value) === "{}" && (property !== "callback"))) {
            delete object[property];
        }
    });
}
export function _attachEvent(obj, eventNameWithoutOn, handlerRef) {
    var result = false;
    if (isValueAssigned(obj)) {
        if (isValueAssigned(obj.attachEvent)) {
            // IE before version 9
            obj.attachEvent("on" + eventNameWithoutOn, handlerRef);
            result = true;
        }
        else {
            if (isValueAssigned(obj.addEventListener)) {
                // all browsers except IE before version 9
                obj.addEventListener(eventNameWithoutOn, handlerRef, false);
                result = true;
            }
        }
    }
    return result;
}
//# sourceMappingURL=Utils.js.map